import useHandlePromotions from "hooks/useHandlePromotions";
import React, { useCallback, useContext, useEffect, useState } from "react";
import applySequentialDiscounts from "utils/applySequentialDiscount";

import ActionButton from "../action_button";
import MissingSpaces from "../missing_spaces";
import PriceBreakdown from "../price_breakdown";
import TotalPrice from "../total_price";
import { BookingDataContext } from "containers/data_context";

export default function Summary(props) {
  const {
    selectedRatesByRoom,
    isDatesSelected,
    isRateSelected,
    missingSpaces,
    totalPrice,
    currency,
    loading,
    update,
    onSearch,
    onBook,
    property,
  } = props;

  const { getRoomPromotions } = useHandlePromotions();

  const [promotions, setPromotions] = useState([]);
  const { channelId } = useContext(BookingDataContext);
  const getRoomPromotionsCallback = useCallback(getRoomPromotions, [selectedRatesByRoom]);

  useEffect(() => {
    let promos = [];
    Object.keys(selectedRatesByRoom).forEach((roomId) => {
      let selectedRates = selectedRatesByRoom[roomId]?.selectedRates;

      if (selectedRates) {
        selectedRates.forEach((sr) => {
          const roomsPromos = getRoomPromotionsCallback(roomId);
          let totalExclusiveTax = 0;

          if (sr?.taxes) {
            sr.taxes.forEach((tax) => {
              if (!tax?.inclusive) {
                totalExclusiveTax = totalExclusiveTax += parseFloat(tax?.amount);
              }
            });
          }
          const rateTotalPriceAfterTax = parseFloat(sr?.totalPrice) - totalExclusiveTax;

          const roomDiscounts = applySequentialDiscounts(rateTotalPriceAfterTax, roomsPromos);
          promos.push({
            ratePlan: sr,
            ...roomDiscounts,
          });
        });
      }
    });
    setPromotions(promos);
  }, [selectedRatesByRoom, getRoomPromotionsCallback]);

  const applyPromoDiscount = () => {
    let price = totalPrice;
    promotions.forEach((promo) => {
      promo.discountSequences.forEach((ds) => {
        price = price - promo?.ratePlan?.amount * ds?.discountAmount;
      });
    });
    return price;
  };

  const data = JSON.parse(localStorage.getItem("userInfo"));
  const discount = data?.channelId === channelId ? data && data?.discount : null;
  let promoDiscountedPrice = promotions?.length > 0 ? applyPromoDiscount() : totalPrice;
  let discountedAmount = 0;

  if (discount > 0 || discount === 0) {
    discountedAmount = (promoDiscountedPrice * discount) / 100;
  }

  const finalTotalPrice = promoDiscountedPrice - discountedAmount;

  return (
    <>
      {update ? (
        <ActionButton
          isDatesSelected={isDatesSelected}
          missingSpaces={missingSpaces}
          total={totalPrice}
          update={update}
          currency={currency}
          loading={loading}
          onSearch={onSearch}
        />
      ) : (
        <div>
          {isRateSelected && (
            <>
              <PriceBreakdown selectedRatesByRoom={selectedRatesByRoom} currency={currency} />
              <TotalPrice
                isMember={data && data?.login_type === "member"}
                promotions={promotions}
                totalPrice={totalPrice}
                currency={currency}
                discount={discount}
                finalTotalPrice={finalTotalPrice}
                discountedAmount={discountedAmount}
              />
              <MissingSpaces missingSpaces={missingSpaces} />
            </>
          )}

          <ActionButton
            isDatesSelected={isDatesSelected}
            isRateSelected={isRateSelected}
            missingSpaces={missingSpaces}
            total={finalTotalPrice}
            currency={currency}
            loading={loading}
            onBook={onBook}
            onSearch={onSearch}
          />
        </div>
      )}
    </>
  );
}
